import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a762a14&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a762a14')) {
      api.createRecord('1a762a14', component.options)
    } else {
      api.reload('1a762a14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a762a14&", function () {
      api.rerender('1a762a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notifications/update/index.vue"
export default component.exports